module.exports = Studio.libraries['react'];